module.exports = __webpack_public_path__ + "img/update.45303072.png";